import { useParams } from "react-router-dom";

import posts from "../../posts.json";
import { slugify } from "../../utils";
import Post from "../Post";
import styles from "./index.module.css";

import striptags from "striptags";

const PostDetail = () => {
  const { slug } = useParams();
  const slugUrlParam = slug.toLowerCase();

  const page = posts.find((t) => {
    const stripped = striptags(t?.title);
    const slugified = slugify(stripped);
    return slugified === slugUrlParam;
  });

  if (!page) {
    return <div>404 - Page Not Found</div>;
  }

  const { title = "" } = page || {};

  return (
    <div className={styles.posts}>
      <Post key={title} post={page} />
    </div>
  );
};

export default PostDetail;
